import { Controller } from "stimulus"
import posthog from 'posthog-js'

const COOKIE_NAME = 'dislikeEventsCounter'

export default class extends Controller {

  trigger(event) {
    const current = this.element.dataset.feedback

    if (current === 'liked' || current === 'disliked') {
      event.preventDefault()
      event.stopPropagation()
      this.element.querySelector(`form.${current} .chat-feedback__option`)?.click()
      return
    }

    this.dropdownController?.toggle(event)
  }

  handleFeedback(event) {
    const [data] = event.detail
    const feedback = event.target.dataset.feedback
    const clicked = data.action === 'clicked'

    this.element.dataset.feedback = clicked ? feedback : 'unset'
    this.dropdownController?.close()
    this.syncTriggerLabel()
    this.triggerElement?.focus()

    if (data.flash && clicked) {
      flash_message(data.flash.type, data.flash.message)
    }

    if (feedback === 'disliked' && clicked) { this.updateDislikeEvent(); }
  }

  syncTriggerLabel() {
    const trigger = this.triggerElement
    if (!trigger) return

    const label = trigger.dataset[`label${this.element.dataset.feedback.replace(/^./, c => c.toUpperCase())}`]
    if (label) trigger.setAttribute('aria-label', label)
  }

  get triggerElement() {
    return this.element.querySelector('.chat-feedback__trigger')
  }

  get dropdownController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'dropdown')
  }

  updateDislikeEvent(){
    const new_count = this.getDislikedCount() + 1
    const cookieString = [
      `${COOKIE_NAME}=${new_count}`,
      'path=/',
      'SameSite=Strict'
    ].join('; ')

    document.cookie = cookieString
    if(new_count == 3){ this.triggerPostHogSurvey(); }
  }

  getDislikedCount(){
    const cookieValue = document.cookie
      .split('; ')
      .find(cookie => cookie.startsWith(`${COOKIE_NAME}=`))
      ?.split('=')[1]
    const parsed = parseInt(cookieValue, 10)
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0
  }

  triggerPostHogSurvey(){
    posthog.capture('survey_triggered_disliked_message', { event_properties: { type: 'survey_triggers' } })
  }
}
